/* eslint-disable max-lines-per-function */
import React, { useState } from 'react';
import {
    TableCell,
    TableRow
} from '@material-ui/core';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import DeleteIcon from '@material-ui/icons/Delete';
import {
    menu, formatDateForComponent, formatDatePaidForComponent
} from '../utils/utils';
import { checkPermissions } from '#/permissions';
import { roles } from '#/constants';
import _uniqueId from 'lodash/uniqueId';
import dayjs from 'dayjs';


const BulkInsertRow = props => {

    const {
        data,
        deleteOrder,
        saveOrder,
        amenityTags,
        role,
        unitMenu,
        paidMenu,
        makeAmenityList,
        styles,
        findUnitType
    } = props;

    const [unitType, setUnitType] = useState('Unit');
    const [paid, setPaid] = useState(data.paid === 'Yes');
    const [amenityList, setAmenityList] = useState([]);


    const isAdmin = checkPermissions([roles.admin, roles.regional_manager_admin], role);
    const handleChange = (name, value) => {

        if (!name) {
            return;
        }

        data[name] = value;

        saveOrder(data);
    };

    const FormBox = props => (
        <Box
            sx={{
                my: 0.8
            }}
        >
            { props.children }
        </Box>
    );

    const paddingStyle = isAdmin
        ? {
            paddingLeft: 2,
            paddingRight: 2

        }
        : {
            paddingLeft: 0,
            paddingRight: 0

        };

    const FormTableCell = props => (


        <TableCell
            style={{
                paddingLeft: paddingStyle.paddingLeft,
                paddingRight: paddingStyle.paddingRight

            }}
            onBlur={e => handleChange(e.target.name, e.target.value)}
        >
            { props.children }
        </TableCell>
    );


    const handleUnitChange = value => {

        setUnitType(findUnitType(value));
        handleChange('unit', value);
    };


    const handleTypeChange = value => {

        setAmenityList(makeAmenityList(value));

        handleChange('tag', value);
    };

    const handlePaid = value => {

        if (value === 'Yes'){
            setPaid(true);
        }
        else if (value === 'No'){
            setPaid(false);
        }

        handleChange('paid', value);

        if (value === 'Yes'){
            handleChange('date_paid', dayjs().format('YYYY-MM-DD').toString());
        }
        else if (value === 'No'){
            handleChange('date_paid', '');
        }


    };

    if (isAdmin){
        return (

            <TableRow key={data.id}>
                <FormTableCell>
                    <FormBox>
                        <Autocomplete
                            disablePortal
                            variant='outlined'
                            name='unit_space_name'
                            label={ unitType || 'Unit' }
                            freeSolo
                            options={unitMenu}
                            defaultValue={data.unit}
                            sx={{ width: 120 }}
                            renderInput={
                                params => (
                                    <TextField
                                        {...params}
                                        value={data.unit}
                                        label={unitType || ''}
                                    />
                                )
                            }
                            onBlur={e => handleUnitChange(e.target.value)}
                        />
                    </FormBox>

                </FormTableCell>

                <FormTableCell>
                    <FormBox>
                        <TextField
                            name='type'
                            label='Tag'
                            sx={{ width: 150 }}
                            variant='outlined'
                            select
                            required={true}
                            defaultValue={data.tag}
                            onChange={e => handleTypeChange(e.target.value)}
                        >
                            {amenityTags && amenityTags.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </FormBox>
                </FormTableCell>
                <FormTableCell>
                    <FormBox>
                        <TextField
                            name='amenity_name'
                            label='Type'
                            sx={{ width: 150 }}
                            variant='outlined'
                            select
                            required={true}
                            defaultValue={data.amenity_name}
                        >
                            {amenityList && amenityList.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </FormBox>
                </FormTableCell>
                <FormTableCell>
                    <FormBox>
                        <TextField
                            sx={{ width: 70 }}
                            name='paid'
                            label='Paid'
                            defaultValue={data?.paid || 'No'}
                            variant='outlined'
                            select
                            onChange={e => handlePaid(e.target.value)}
                        >
                            {menu && paidMenu.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}


                        </TextField>
                    </FormBox>
                </FormTableCell>
                {paid && <FormTableCell>
                    <FormBox>
                        <TextField id='date_paid'
                            label='Date Paid'
                            type='date'
                            defaultValue={formatDatePaidForComponent(data?.date_paid) || ''}
                            variant='outlined'
                            name='date_paid'
                            InputLabelProps={{
                                shrink: true
                            }} />
                    </FormBox>
                </FormTableCell>}
                {!paid && <FormBox></FormBox>}
                <FormTableCell>
                    <FormBox>
                        <TextField
                            name='check_number'
                            label='Check N.'
                            defaultValue={data?.check_number}
                            variant='outlined'
                            onBlur={e => handleChange(e, data.id)}
                        />
                    </FormBox>
                </FormTableCell>
                <FormTableCell>
                    <FormBox>
                        <TextField
                            id='ordered'
                            label= 'Date Ordered'
                            type='date'
                            defaultValue={formatDateForComponent(data?.ordered) || ''}
                            variant='outlined'
                            name='ordered'
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </FormBox>
                </FormTableCell>
                <FormTableCell>
                    <FormBox>
                        <TextField
                            name='manager_notes'
                            label='Manager Notes'
                            minRows={1}
                            inputProps={{
                                maxLength: 255
                            }}
                            multiline
                            defaultValue={data?.manager_notes}
                            variant='outlined'
                        />
                    </FormBox>
                </FormTableCell>
                <FormTableCell>
                    <FormBox>
                        <TextField
                            name='owner_notes'
                            label='Owner Notes'
                            minRows={1}
                            inputProps={{
                                maxLength: 255
                            }}
                            multiline
                            defaultValue={data?.owner_notes}
                            variant='outlined'
                        />
                    </FormBox>
                </FormTableCell>
                <FormTableCell>
                    <FormBox>
                        <DeleteIcon
                            color='secondary'
                            onClick={() => deleteOrder(data.id)}
                            className={styles.hover}
                        />
                    </FormBox>
                </FormTableCell>
            </TableRow>
        );
    }

    if (!isAdmin){
        return (

            <TableRow key={data.id}>
                <FormTableCell>
                    <FormBox>
                        <Autocomplete
                            disablePortal
                            variant='outlined'
                            name='unit_space_name'
                            label={ unitType || 'Unit' }
                            freeSolo
                            options={unitMenu}
                            defaultValue={data.unit}
                            sx={{ width: 120 }}
                            renderInput={
                                params => (
                                    <TextField
                                        {...params}
                                        value={data.unit}
                                        label={unitType || ''}
                                    />
                                )
                            }
                            onBlur={e => handleUnitChange(e.target.value)}
                        />
                    </FormBox>

                </FormTableCell>

                <FormTableCell>
                    <FormBox>
                        <TextField
                            name='type'
                            label='Tag'
                            sx={{ width: 150 }}
                            variant='outlined'
                            select
                            required={true}
                            defaultValue={data.tag}
                            onChange={e => handleTypeChange(e.target.value)}
                        >
                            {amenityTags && amenityTags.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </FormBox>
                </FormTableCell>
                <FormTableCell>
                    <FormBox>
                        <TextField
                            name='amenity_name'
                            label='Type'
                            sx={{ width: 150 }}
                            variant='outlined'
                            select
                            required={true}
                            defaultValue={data.amenity_name}
                        >
                            {amenityList && amenityList.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </FormBox>
                </FormTableCell>
                <FormTableCell>
                    <FormBox>
                        <TextField
                            id='ordered'
                            label= 'Date Ordered'
                            type='date'
                            defaultValue={formatDateForComponent(data?.ordered) || ''}
                            variant='outlined'
                            name='ordered'
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </FormBox>
                </FormTableCell>
                <FormTableCell>
                    <FormBox>
                        <TextField
                            name='manager_notes'
                            label='Manager Notes'
                            minRows={1}
                            inputProps={{
                                maxLength: 255
                            }}
                            multiline
                            defaultValue={data?.manager_notes}
                            variant='outlined'
                            sx={{ width: 800 }}
                        />
                    </FormBox>
                </FormTableCell>
                <FormTableCell>
                    <FormBox>
                        <DeleteIcon
                            color='secondary'
                            onClick={() => deleteOrder(data.id)}
                            className={styles.hover}
                        />
                    </FormBox>
                </FormTableCell>
            </TableRow>
        );
    }
};


export default BulkInsertRow;
